import { Route, RouteConfig } from 'vue-router';
import { HomePaths } from '@/core/constants';

export const HomeRoutes: RouteConfig = {
    path: HomePaths.Index,
    name: 'Home',
    redirect: HomePaths.News,
    component: () => import('@/views/home/Index.vue'),
    children: [
        {
            path: HomePaths.News,
            name: 'News',
            component: () => import('@/views/home/news/News.vue')
        },
        {
            path: HomePaths.Profile,
            name: 'Profile',
            component: () => import('@/views/home/profile/Profile.vue'),
            meta: {
                requiresAuth: false
            }
        },
        {
            path: HomePaths.CancelResetPassword,
            name: 'CancelResetPassword',
            component: () => import('@/views/home/user/CancelResetPassword.vue'),
            props: (route: Route) => ({
                token: route.params.token
            }),
            meta: {
                requiresAuth: false
            }
        },
        {
            path: HomePaths.ResetPassword,
            name: 'ResetPassword',
            component: () => import('@/views/home/user/ResetPassword.vue'),
            props: (route: Route) => ({
                token: route.params.token
            }),
            meta: {
                requiresAuth: false
            }
        },
        {
            path: HomePaths.UserProfile,
            name: 'UserProfile',
            component: () => import('@/views/home/user/Profile/Profile.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: HomePaths.DonateSucess,
            name: 'DonateSucess',
            component: () => import('@/views/home/user/DonateSuccess.vue'),
            props: (route) => ({
                paymentId: route.query.paymentId,
                token: route.query.token,
                payerId: route.query.PayerID
            }),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: HomePaths.Notifications,
            name: 'Notifications',
            component: () => import('@/views/home/user/Notifications.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: HomePaths.Gravatar,
            name: 'Gravatar',
            component: () => import('@/views/home/user/Gravatar.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: HomePaths.Armory,
            name: 'Armory',
            component: () => import('@/views/home/armory/Index.vue'),
            children: [
                {
                    path: HomePaths.ArmoryRealm,
                    name: 'ArmoryRealm',
                    component: () => import('@/views/home/armory/ArmoryRealm.vue'),
                    props: (route) => ({
                        realmId: parseInt(route.params.realmId)
                    }),
                    children: [
                        {
                            path: HomePaths.ArmoryCharacters,
                            name: 'ArmoryCharacters',
                            component: () => import('@/views/home/armory/characters/ArmoryCharacters.vue'),
                            props: (route) => ({
                                realmId: parseInt(route.params.realmId)
                            })
                        },
                        {
                            path: HomePaths.ArmoryCharacter,
                            name: 'ArmoryCharacter',
                            component: () => import('@/views/home/armory/characters/ArmoryCharacter.vue'),
                            props: (route) => ({
                                realmId: parseInt(route.params.realmId),
                                name: route.params.name
                            })
                        },
                        {
                            path: HomePaths.ArmoryGuilds,
                            name: 'ArmoryGuilds',
                            component: () => import('@/views/home/armory/guilds/ArmoryGuilds.vue'),
                            props: (route) => ({
                                realmId: parseInt(route.params.realmId)
                            })
                        },
                        {
                            path: HomePaths.ArmoryGuild,
                            name: 'ArmoryGuild',
                            component: () => import('@/views/home/armory/guilds/ArmoryGuild.vue'),
                            props: (route) => ({
                                realmId: parseInt(route.params.realmId),
                                name: route.params.name
                            })
                        }
                    ]
                }
            ]
        },
        {
            path: HomePaths.OnlinePlayers,
            name: 'Online Players',
            component: () => import('@/views/home/pages/OnlinePlayers.vue')
        },
        {
            path: HomePaths.Changelog,
            name: 'Changelog',
            component: () => import('@/views/home/pages/Changelog.vue')
        },
        {
            path: HomePaths.PvPStatistics,
            name: 'PvPStatistics',
            component: () => import('@/views/home/pages/PvPStatistics.vue')
        },
        {
            path: HomePaths.Vote,
            name: 'Vote',
            component: () => import('@/views/home/user/Vote.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: HomePaths.Donate,
            name: 'Donate',
            component: () => import('@/views/home/user/Donate.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: HomePaths.Chat,
            name: 'Chat',
            component: () => import('@/views/home/chat/Chat.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: HomePaths.BugTracker,
            name: 'BugTracker',
            redirect: HomePaths.BugTrackerSearch,
            component: () => import('@/views/home/bugtracker/BugTracker.vue'),
            meta: {
                requiresAuth: false
            },
            children: [
                {
                    path: HomePaths.BugTrackerSearch,
                    name: 'BugTrackerSearch',
                    component: () => import('@/components/frontpage/bugtracker/BugTrackerSearch.vue')
                },
                {
                    path: HomePaths.BugTrackerCreateIssue,
                    name: 'BugTrackerCreateIssue',
                    component: () => import('@/components/frontpage/bugtracker/BugTrackerCreateIssue.vue'),
                    meta: {
                        requiresAuth: true
                    },
                    children: [
                        {
                            path: HomePaths.BugTrackerCreateIssueSuccess,
                            name: 'BugTrackerCreateSuccess',
                            component: () => import('@/components/frontpage/bugtracker/BugTrackerCreateSuccess.vue')
                        }
                    ]
                },
                {
                    path: HomePaths.BugTrackerDetailsPage,
                    name: 'BugTrackerDetailsPage',
                    component: () => import('@/components/frontpage/bugtracker/BugTrackerDetailsPage.vue'),
                    props: (route) => ({
                        id: parseInt(route.params.id)
                    }),
                    meta: {
                        requiresAuth: false
                    }
                }
            ]
        },
        {
            path: HomePaths.ContentPage,
            name: 'ContentPage',
            component: () => import('@/views/home/ContentPage.vue'),
            meta: {
                requiresAuth: false
            }
        }
    ]
};
